import React, { useState } from 'react';
import { Grid } from '@mui/material';
import { Pagination as MaterialPagination } from '@mui/material';
import { usePagination } from '@mui/lab';
import { useIntl } from 'react-intl';
import './pagination.scss';

const Pagination = ({
    page = 1,
    rowsPerPage = 50,
    count = 0,
    valuesPerPage,
    hideAllInPagination = false,
    hideNextButton = false,
    onChangePage,
    onChangeRowsPerPage,
}) => {
    const { messages } = useIntl();
    const availablePages = Math.ceil(count / rowsPerPage);
    const [allRows, setAllRows] = useState(false);

    const handleChangeRowsPerPage = (value) => {
        setAllRows(value === 'ALL');
        onChangeRowsPerPage && onChangeRowsPerPage(value);
    };

    const { items } = usePagination({
        count: availablePages,
        page,
        onChange: onChangePage,
        hideNextButton,
    });

    const rowOptions = valuesPerPage || [10, 25, 50, 100];

    return (
        <div className="dv-pagination-container">
            <Grid container direction="row" justifyContent="space-between" alignItems="center">

                {/* Page navigation — left */}
                <Grid
                    item
                    xs={12}
                    lg={8}
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    className="dv-pagination-controls"
                >
                    {!allRows && (
                        <>
                            <MaterialPagination
                                style={{ display: 'none' }}
                                count={availablePages}
                                page={page}
                                onChange={onChangePage}
                            />
                            <ul className="MuiPagination-ul">
                                {items.map(({ page: pageNum, type, selected, onClick, disabled }, index) => {
                                    if (type === 'start-ellipsis' || type === 'end-ellipsis') {
                                        return <li key={index}><span style={{ padding: '0 4px' }}>…</span></li>;
                                    }
                                    if (type === 'page') {
                                        return (
                                            <li key={index}>
                                                <span
                                                    className={`dv-page-circle ${selected ? 'active' : ''}`}
                                                    onClick={onClick}
                                                >
                                                    {pageNum}
                                                </span>
                                            </li>
                                        );
                                    }
                                    return (
                                        <li key={index}>
                                            <button
                                                type="button"
                                                className="dv-btn-link"
                                                onClick={onClick}
                                                disabled={disabled}
                                            >
                                                {type === 'previous'
                                                    ? (messages?.['prev'] || 'prev')
                                                    : (messages?.['nextp'] || 'next')}
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                        </>
                    )}
                </Grid>

                {/* Rows per page — right */}
                <Grid
                    item
                    xs={12}
                    lg={4}
                    container
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="center"
                    className="dv-pagination-controls"
                >
                    {rowOptions.map((value) => (
                        <span
                            key={value}
                            className={`dv-page-circle ${rowsPerPage == value && !allRows ? 'active' : ''}`}
                            onClick={() => handleChangeRowsPerPage(value)}
                        >
                            {value}
                        </span>
                    ))}

                    {!hideAllInPagination && (
                        <span
                            className={`dv-page-circle ${allRows ? 'active' : ''}`}
                            onClick={() => handleChangeRowsPerPage('ALL')}
                        >
                            {messages?.['all'] || 'all'}
                        </span>
                    )}

                    <span className="dv-page-circle cursor-auto">
                        {messages?.['perPage'] || 'per page'}
                    </span>
                </Grid>

            </Grid>
        </div>
    );
};

export default Pagination;
